
import Tab from 'vux/src/components/tab/tab.vue'
import TabItem from 'vux/src/components/tab/tab-item.vue'
import Swiper from 'vux/src/components/swiper/swiper.vue'
import SwiperItem from 'vux/src/components/swiper/swiper-item.vue'

import { Step, Steps, Popup } from 'vant'
import { datagrid, getMyMedicalDec, getMedicalLog } from '@/api/yiliaohuzhu'
import Scroll from '@/components/scroller'
export default {
components: {
Tab,
TabItem,
Swiper,
SwiperItem,
vanStep: Step,
vanSteps: Steps,
vanPopup: Popup
},
data () {
return {
id: this.$route.params.id,
tabactive: 0,
cblist: '',
bzlist: '',
page: 1,
rows: 10,
pageSize: 8,
pageCurrent: 1,
moremsg1: '点击加载更多',
moremsg2: '点击加载更多',
nomore1: false,
nomore2: false,
showstep: false,
stepList: []
}
},
computed: {
userid () {
return this.$store.state.user.userid
}
},
created () {
this.getcblist()
this.getbzlist()
},
mounted () {
},
methods: {
poplog (id, type) {
getMedicalLog({
medicalid: id
}).then(data => {
this.stepList = data.obj
this.stepList.forEach(el => {
if (el.status == 1) {
this.$set(el, 'statusname', '审核通过')
} else if (el.status == 2) {
this.$set(el, 'statusname', '审核未通过')
} else if (el.status == 3) {
this.$set(el, 'statusname', '申请')
} else if (el.status == 4) {
this.$set(el, 'statusname', '修改')
} else if (el.status == 12) {
this.$set(el, 'statusname', '待提交')
} else if (el.status == 13) {
this.$set(el, 'statusname', '待提交修改')
} else if (el.status == 14) {
this.$set(el, 'statusname', '提交')
}
this.showstep = true
})
})
},
getcblist () {
datagrid({
idCard: this.id,
page: this.page,
rows: this.rows
}).then(res => {
if (res.obj !== null) {
if (res.obj.length > 0) {
this.cblist = [...this.cblist, ...res.obj]
this.moremsg1 = '点击加载更多'
} else {
this.moremsg1 = '没有更多了~'
this.nomore1 = true
}
}
}).catch(e => { this.$router.push({ name: 'yiliaohuzhu' }) })
},
getbzlist () {
getMyMedicalDec({
pageSize: this.pageSize,
pageCurrent: this.pageCurrent,
userid: this.userid,
idCard: this.id
}).then(data => {
if (data.obj !== null) {
if (data.obj.length > 0) {
this.bzlist = [...this.bzlist, ...data.obj]
this.moremsg2 = '点击加载更多'
} else {
this.moremsg2 = '没有更多了~'
this.nomore2 = true
}
} else {
this.moremsg2 = '没有更多了~'
this.nomore2 = true
}
}).catch(e => { window.history.go(-1) })
},
itemclick (index) {
if (this.tabactive !== index) {
this.tabactive = index
}
},
loadmore1 () {
if (!this.nomore1) {
this.moremsg1 = '正在加载中...'
this.page++
this.getcblist()
}
},
loadmore2 () {
if (!this.nomore2) {
this.moremsg2 = '正在加载中...'
this.pageCurrent++
this.getbzlist()
}
},
linktoedit (id, type) {
if (type == '3') {
this.$router.push({ name: 'yiliaohuzhuEdit2', params: { id: id } })
} else {
this.$router.push({ name: 'yiliaohuzhuEdit1', params: { id: id } })
}
}
}
}
